const { permissions } = require('../../../../constants/permissions');

require("./saasSubscription.style.scss");

class SaaSSubscriptionController {
    constructor(
        $scope,
        $filter,
        saasSubscriptionPersistence,
        storageService,
        notificationService,
        sharedPersistenceService,
        virtualMachinesPersistence,
        principalService,
        dialogService,
        utilsService,
        validationsService,
        iamPersistenceService,
    ) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.saasSubscriptionPersistence = saasSubscriptionPersistence;
        this.storageService = storageService;
        this.utilsService = utilsService;
        this.validationsService = validationsService;
        this.notificationService = notificationService;
        this.principalService = principalService;
        this.iamPersistenceService = iamPersistenceService;
        this.virtualMachinesPersistence = virtualMachinesPersistence;
        this.dialogService = dialogService;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.showModal = false;
        this.title = this.$filter('translate')('main.nav.top.saasSubscription.title');

        this.saasSubscriptionList = [];
        // this.disableUpdate = true;
        this.busy = true;

        this.$scope.$watchCollection(
            () => this.selectedSaasSubscription,
            (newValue, oldValue) => {
                if (!oldValue || !newValue) return;
                if (this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET)) {
                    this.busy = true;
                    this.setSaasSubscriptionData().finally(() => {
                        this.busy = false;
                    });
                } else {
                    this.busy = false;
                }
            }
        );
    }

    $onInit() {
        this.actionButtons = [
            {
                title: this.$filter('translate')('main.nav.top.admin.saasSubscription.button.update'),
                action: () => {
                    this.updateBillingPlan();
                },
                isDisabled: () => this.isUpdateSaaSInfoDisabled(),
                isVisible: () => this.saasSubscriptionList.length > 0,
                id: 'update-billing-button'
            },
            {
                title: this.$filter('translate')('main.nav.top.admin.saasSubscription.button.unsubscribe'),
                action: () => {
                    this.unsubscribe();
                },
                isDisabled: () => this.isUnsubscribeDisabled(),
                isVisible: () => this.saasSubscriptionList.length > 0,
                id: 'unsubscribe-button',
                btnClass: 'ctx-btn-gradient',
            }
        ];
        this.billingTooltip = this.$filter('translate')('main.nav.top.help.subscription.tooltip');
    }

    async onOpen() {
        this.busy = true;
        this.listOfResourceGroups = [];
        this.saasSubscriptionList = await this.saasSubscriptionPersistence.getSaasSubscriptions();
        this.selectedSaasSubscription = this.saasSubscriptionList[0];
    }

    updateBillingPlan() {
        this.dialogService.showYesNo(this.$filter('translate')('main.nav.top.admin.saasSubscription.billinUpdateYesNo'), this.$filter('translate')('main.nav.top.admin.saasSubscription.billinUpdateYesNoTitle'), null, 'billing-plan-update')
            .then(result => {
                if (result) {
                    var data = {
                        planId: this.selectedBillingPlan.value,
                        emails: this.saasSubscriptionData.customer.emails
                    };
                    this.saasSubscriptionPersistence.updateBillingPlan(this.selectedSaasSubscription.value, data).then(
                        resp => {
                            this.notificationService.pop(resp.data.message);
                            this.busy = true;
                            this.setSaasSubscriptionData().finally(() => {
                                // this.disableUpdate = this.selectedBillingPlan.value === this.saasSubscriptionData.planId ? true : false;
                                this.busy = false;
                            });
                        }
                    );
                }
            });
    }

    unsubscribe() {
        this.dialogService.showYesNo(this.$filter('translate')('main.nav.top.admin.saasSubscription.unsubscribeYesNo', { fullfName: this.saasSubscriptionData.name }), this.$filter('translate')('main.nav.top.admin.saasSubscription.unsubscribeYesNoTitle'), null, 'unsubscribe')
            .then(result => {
                if (result) {
                    this.saasSubscriptionPersistence.unsubscribeSaasSubscription(this.selectedSaasSubscription.value).then(
                        resp => {
                            this.notificationService.pop(resp.data.message);
                            this.busy = true;
                            this.principalService.forceLogout();
                        }
                    );
                }
            });
    }

    async setSaasSubscriptionData() {
        this.saasSubscriptionData = await this.saasSubscriptionPersistence.getSaasSubscriptionData(this.selectedSaasSubscription.value);
        this.listOfResourceGroups = await this.saasSubscriptionPersistence.getResourceGroupsFromAzure(this.saasSubscriptionData.subscriptionUuid);
        this.billingList = await this.saasSubscriptionPersistence.getBillingPlans(this.selectedSaasSubscription.value);
        this.selectedBillingPlan = this.billingList.filter(item => item.value === this.saasSubscriptionData.planId)[0];
        // this.billingAccountViewerInput = sameSubscription ? this.billingAccountViewerInput : this.selectedSubscription.value.procurementAccountDto.customer.billingAccountViewerEmail;
    }

    update(billingAccountViewerInput, accountId) {
        return this.crudService.post(
            `procurement/accounts/${accountId}:assignNewBillingAccountViewer`,
            {
                billingAccountViewerEmail: billingAccountViewerInput
            },
            null,
            true
        );
    }

    onClose() {
        this.billingAccountViewerInput = "";
    }

    isSaaSInfoVisible() {
        return this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET);
    }

    isUpdateSaaSInfoDisabled() {
        return !this.iamPersistenceService.hasPermissions(permissions.SUB_INFO_GET) || !this.iamPersistenceService.hasPermissions(permissions.SUB_UPDATE) || !this.dialogForm.$valid || !this.saasSubscriptionData || this.saasSubscriptionData.customer.emails.length === 0;
    }

    isUnsubscribeDisabled() {
        return !this.iamPersistenceService.hasPermissions(permissions.SUB_UNSUBSCRIBE);
    }
}

SaaSSubscriptionController.$inject = [
    "$scope",
    "$filter",
    "saasSubscriptionPersistence",
    "storageService",
    "notificationService",
    "sharedPersistenceService",
    "virtualMachinesPersistence",
    "principalService",
    "dialogService",
    "utilsService",
    "validationsService",
    "iamPersistenceService",
];

const saasSubscriptionComponent = {
    controller: SaaSSubscriptionController,
    template: require("./saasSubscription.template.html"),
    bindings: {
        showModal: "="
    }
};

module.exports = saasSubscriptionComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/saasSubscription/saasSubscription.component.js